module.exports = __webpack_public_path__ + "img/Traiteur_2.08a6a6b0.jpg";